import { AccommodationPlaceCategory, AccommodationPlaceType, TravelDistancesBetweenPointsResponseFragment } from '@graphql/generated';
import { AccommodationPlaceV2 } from '../pages/CustomProperty/CustomPropertyForm.types';
import { distanceInMiles } from '@shared/utils/distanceInMiles';
import { useEventPlaces } from '@shared/utils/eventPlace';

export interface AccommodationPlaceData
  extends Readonly<{
    __typename: 'AccommodationPlaceV2' | 'AccommodationPlace';
    type?: AccommodationPlaceType | null;
    userNote?: string | null;
    name?: string | null;
    description?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    country?: string | null;
    email?: string | null;
    phone?: string | null;
    starRating?: number | null;
    url?: string | null;
    lat?: number | null;
    long?: number | null;
    zhId?: string | null;
    googlePlaceId?: string | null;
    joyPlaceId?: string | null;
    category?: AccommodationPlaceCategory | null;
    customName?: string | null;
    customAddress?: string | null;
    customUrl?: string | null;
    customPhone?: string | null;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    photos?: string[];
    customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
    displayPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
    isPhotoHidden?: boolean | null;
    isFromAccommodationCatalog?: boolean;
    distance?: number | null;
    distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
    accommodationRoomBlock?: {
      __typename?: 'AccommodationPlaceRoomBlock';
      bookingUrl?: string | null;
      checkInDate?: string | null;
      checkOutDate?: string | null;
      cutoffDate?: string | null;
      isJoyManagedRoomBlock?: boolean | null;
      numberOfRoomsReserved?: number | null;
      pricePerNight?: number | null;
      strikeoutPricePerNight?: number | null;
    } | null;
    isFavorite?: boolean | null;
    isHostStayingHere?: boolean | null;
    isCustomLinkEnabled?: boolean | null;
  }> {}

export const useAlignAccommodationPlaceData = (data?: AccommodationPlaceV2) => {
  const { origin } = useEventPlaces();

  const customPropertyData = data
    ? {
        id: data.id,

        name: data.name,
        address: data.address,
        phone: data.phone,

        customName: data.customName,
        customAddress: data.customAddress,
        customPhone: data.customPhone,
        customUrl: data.customUrl,

        url: data.url,
        postalCode: data.postalCode,
        category: data.category,
        city: data.city,
        state: data.state,
        country: data.country,
        lat: data.lat,
        long: data.long,
        userNote: data.userNote,
        customPhoto: data.customPhoto,
        starRating: data?.starRating,
        photo: data.photo,
        displayPhoto: data.customPhoto || data.photo,
        isPhotoHidden: data.isPhotoHidden,
        zhId: data.zhId,
        googlePlaceId: data.googlePlaceId,
        joyPlaceId: data.joyPlaceId,
        __typename: data.__typename,
        isFromAccommodationCatalog: data.isFromAccommodationCatalog,
        accommodationRoomBlock: data.accommodationRoomBlock,
        isFavorite: data.isFavorite,
        isHostStayingHere: data.isHostStayingHere,
        isCustomLinkEnabled: data.isCustomLinkEnabled,
        distance: distanceInMiles(origin, { lat: data.lat, lng: data.long }),
        distances: data.distances,
      }
    : null;
  return customPropertyData;
};
